module.exports = __webpack_public_path__ + "img/image150.45459217.png";